import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { Adapter, API } from '@setplex/tria-api'
import type { Store } from 'effector'
import type { AdapterDefaults, DeviceType } from './index.h'

import { use as appearance } from './entities/appearance'
import { use as banners } from './entities/banners'
import { use as catchups } from './entities/catchups'
import { use as continueWatching } from './entities/continue-watching'
import { use as externalContent } from './entities/external-content'
import { use as search } from './entities/global-search'
import { use as i18n } from './entities/i18n'
import { use as liveEvents } from './entities/live-events'
import { use as notifications } from './entities/notifications'
import { use as partnerProgram } from './entities/partnerProgram'
import { use as profiles } from './entities/profiles'
import { use as session } from './entities/session'
import { use as showBundles } from './entities/showBundles'
import { use as subscriber } from './entities/subscriber'
import { use as subscriptions } from './entities/subscriptions'
import { use as tv } from './entities/tv'
import { use as tvBundles } from './entities/tvBundles'
import { use as tvshows } from './entities/tvshows'
import { use as vodBundles } from './entities/vodBundles'
import { use as vods } from './entities/vods'
import { use as events } from './events'
import { use as sign } from './sign'
import { setDeviceType } from './utils/images'

// import { initErrorHandling } from './events/errors'

export { i18nCacheRule, SUBSCRIBER_CACHE_TAG } from './cache'
export { clearPageReuseCache } from './utils/pageReuse'
export { observe } from './observe'
export { setLogger } from './utils/logger'

export const adapter =
  ({
    $deviceType,
    client,
  }: {
    $deviceType: Store<DeviceType | null>
    client: WbsClient
  }): Adapter =>
  (
    api: API,
    defaults: AdapterDefaults = {
      count: 36,
      sortOrder: 'asc',
    }
  ) => {
    $deviceType.watch(setDeviceType)

    events(api)
    // initErrorHandling(api)

    sign(client, api.session, api, defaults)
    session(client, api.session, api, defaults)

    appearance(client, api.appearance, api, defaults)
    banners(client, api.banners, api, defaults)
    liveEvents(client, api.liveEvents, api, defaults)
    subscriber(client, api.subscriber, api, defaults)
    tv(client, api.tv, api, defaults)
    tvBundles(client, api.tvBundles, api, defaults)
    vodBundles(client, api.vodBundles, api, defaults)
    showBundles(client, api.showBundles, api, defaults)
    tvshows(client, api.tvshows, api, defaults)
    vods(client, api.vods, api, defaults)
    search(client, api.globalSearch, api)
    catchups(client, api.catchups, api, defaults)
    continueWatching(client, api.continueWatching, api, defaults)
    notifications(client, api.notifications, api, defaults)
    profiles(client, api.profiles, api, defaults)
    i18n(client, api.i18n, api, defaults)
    partnerProgram(client, api.partnerProgram, api, defaults)
    subscriptions(client, api.subscriptions, api, defaults)
    externalContent(client, api.externalContent, api)
  }
